import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=34346eb4&scoped=true&"
import script from "./Number.vue?vue&type=script&lang=ts&"
export * from "./Number.vue?vue&type=script&lang=ts&"
import style0 from "./Number.vue?vue&type=style&index=0&id=34346eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34346eb4",
  null
  
)

export default component.exports